import { useScrollIndicators } from "../useScrollIndicators";

export const HORIZONTAL_SCROLL_MASK_LEFT = "left";
export const HORIZONTAL_SCROLL_MASK_RIGHT = "right";
export const HORIZONTAL_SCROLL_MASK_BOTH = "both";
export const HORIZONTAL_SCROLL_MASK_NONE = "none";

export const getHorizontalScrollMaskState = (canScrollLeft, canScrollRight) => {
  if (canScrollLeft && canScrollRight) {
    return HORIZONTAL_SCROLL_MASK_BOTH;
  }

  if (canScrollLeft) {
    return HORIZONTAL_SCROLL_MASK_LEFT;
  }

  if (canScrollRight) {
    return HORIZONTAL_SCROLL_MASK_RIGHT;
  }

  return HORIZONTAL_SCROLL_MASK_NONE;
};

export const useHorizontalScrollMask = (containerRef, dependencies = []) => {
  const { canScrollLeft, canScrollRight } = useScrollIndicators(
    containerRef,
    dependencies,
  );

  return {
    canScrollLeft,
    canScrollRight,
    maskState: getHorizontalScrollMaskState(canScrollLeft, canScrollRight),
  };
};

export default useHorizontalScrollMask;
